module.exports = __webpack_public_path__ + "static/media/jc.2fd7b69c.png";